var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.108,
    height: 40.452,
    viewBox: "0 0 57.108 40.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(0 -7.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74459",
    "data-name": "Path 74459",
    d: "M47.59,41.693a4.737,4.737,0,0,0,4.735-4.759l.024-26.175A4.758,4.758,0,0,0,47.59,6H9.518a4.758,4.758,0,0,0-4.759,4.759V36.934a4.758,4.758,0,0,0,4.759,4.759H0a4.758,4.758,0,0,0,4.759,4.759h47.59a4.758,4.758,0,0,0,4.759-4.759ZM9.518,10.759H47.59V36.934H9.518ZM28.554,44.072a2.38,2.38,0,1,1,2.38-2.38A2.387,2.387,0,0,1,28.554,44.072Z",
    transform: "translate(0 1.25)",
    fill: "#fe6831"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.922ac14856c886d2171f8a88cffbefcf.svg";
export { ForwardRef as ReactComponent };